import { render, staticRenderFns } from "./MoveItem.vue?vue&type=template&id=3b7d326e&scoped=true&"
import script from "./MoveItem.vue?vue&type=script&lang=ts&"
export * from "./MoveItem.vue?vue&type=script&lang=ts&"
import style0 from "./MoveItem.vue?vue&type=style&index=0&id=3b7d326e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d326e",
  null
  
)

export default component.exports